export default __webpack_public_path__ + "static/buymeacoffee-f0c782c42a9db375611fbcc18e152950.svg";